// extracted by mini-css-extract-plugin
export var callCard = "_rc-0";
export var callMessageButton = "_rc-1";
export var helpIcon = "_rc-3";
export var helpIconContainer = "_rc-4";
export var verticalDivider = "_rc-2";